const SDG_TARGETS_LIST = 'bfb/SDG/SDG_TARGETS_LIST';
const SDG_TARGETS_LIST_SUCCEEDED = 'bfb/SDG/SDG_TARGETS_LIST_SUCCEEDED';
const SDG_TARGETS_LIST_FAILED = 'bfb/SDG/SDG_TARGETS_LIST_FAILED';

export default {
  SDG_TARGETS_LIST,
  SDG_TARGETS_LIST_SUCCEEDED,
  SDG_TARGETS_LIST_FAILED,
};
